import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Film } from 'lucide-react';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import styles from './StoryboardGallery.module.css';

const StoryboardGallery = () => {
  const navigate = useNavigate();

  const storyboards = [
    { id: 1, title: 'Story 1', thumbnail: '/images/story-1.jpg', type: 'Ad Film' },
    { id: 2, title: 'Story 2', thumbnail: '/images/story-2.jpg', type: 'Short Film' },
    { id: 3, title: 'Story 3', thumbnail: '/images/story-3.jpg', type: 'Ad Film' },
  ];

  return (
    <>
      <Header />
      <div className={styles.container}>
      
        
        <div className={styles.hero}>
          <Film className={styles.heroIcon} />
          <h1 className={styles.title}>Storyboard Gallery</h1>
          <p className={styles.subtitle}>Visual narratives for ads and short films</p>
        </div>

        <div className={styles.grid}>
          {storyboards.map((story) => (
            <div 
              key={story.id} 
              className={styles.card}
              onClick={() => navigate(`/storyboard/${story.id}`)}
            >
              <div className={styles.imageWrapper}>
                <img src={story.thumbnail} alt={story.title} className={styles.image} />
                <div className={styles.overlay}>
                  <span className={styles.viewText}>View Details</span>
                </div>
              </div>
              <div className={styles.cardContent}>
                <h3 className={styles.cardTitle}>{story.title}</h3>
                <span className={styles.badge}>{story.type}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default StoryboardGallery;
